import { render, staticRenderFns } from "./UnitCard.vue?vue&type=template&id=66760459&scoped=true"
import script from "./UnitCard.vue?vue&type=script&lang=js"
export * from "./UnitCard.vue?vue&type=script&lang=js"
import style0 from "./UnitCard.vue?vue&type=style&index=0&id=66760459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66760459",
  null
  
)

export default component.exports